
import Vue from 'vue';
import AvailabilityQueueIndex from '../components/availability_queue/AvailabilityQueueIndex.vue';
Vue.component('availability-queue-index', AvailabilityQueueIndex);

export default Vue.extend({
  components: { AvailabilityQueueIndex },
});
